module.exports = __webpack_public_path__ + "assets/webgl/LM_1_1.abc0b02d.jpg";